import {
    AI_SEND_USER_MESSAGE,
    AI_SEND_USER_MESSAGE_ERROR,
    AI_SEND_USER_MESSAGE_SUCCESS,
    AiActionTypes,
    ChatMessage
} from "../../actions/ai/AiChatBotActions";
import {
    errorFetchingRequestState,
    getInitialRequestState,
    RequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";


export interface AiChatBotState {
    chat: {
        messages: ChatMessage[]
        request: RequestState
    }


}

const initalState: AiChatBotState = {
    chat: {
        messages: [],
        request: getInitialRequestState()
    }
}

export function AiChatBotReducer(
    state: AiChatBotState = initalState,
    action: AiActionTypes
) {

    switch( action.type ) {
        case AI_SEND_USER_MESSAGE:
            return {
                ...state,
                chat: {
                    messages: [ ...state.chat.messages, action.msg ],
                    request: startFetchingRequestState()
                }
            };
        case AI_SEND_USER_MESSAGE_SUCCESS:
            return {
                ...state,
                chat: {
                    messages:  [ ...state.chat.messages, action.msg ],
                    request: successFetchingRequestState()
                }
            };
        case AI_SEND_USER_MESSAGE_ERROR:
            return {
                ...state,
                chat: {
                    ...state.chat,
                    request: errorFetchingRequestState( action.error )
                }
            };
        default:
            return state;
    }

}
